<template>
	<div class="text-h4 text-weight-bold" id="pageTitle">{{ $t(title) }}</div>
	<div class="q-py-xs" id="pageDescription" v-if="description">{{ $t(description) }}</div>
</template>

<style lang="less" scoped src="./error-page.less"></style>
<script lang="ts" src="./error-page.ts"></script>
